import api from './axios';

// PATCH /owner/substores/{substore_id}/ to update substore details
export const patchSubstoreDetails = async (substoreId, data) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Token ${token}` } : {})
  };
  const response = await api.patch(`/owner/substores/${substoreId}/`, data, { headers });
  return response.data;
};
